//统一定义type类型
export const SHOW_LOADING = 'SHOW_LOADING';
export const HIDE_LOADING ='HIDE_LOADING';
export const SHOW_TOAST ='SHOW_TOAST';
export const HIDE_TOAST  ='HIDE_TOAST ';


// WEBPACK FOOTER //
// ./src/store/type.js